module.exports = __webpack_public_path__ + "static/img/help2.5a472db1.jpg";